var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5926 8.87659C15.2014 8.81956 14.8634 8.57354 14.6889 8.21882L12.3183 3.39968C12.1873 3.13344 11.8129 3.13344 11.6819 3.39968L9.3113 8.21882C9.13681 8.57354 8.79882 8.81956 8.40764 8.87659L3.10683 9.64937C2.81946 9.69127 2.69356 10.0539 2.9106 10.2661L6.7463 14.0173C7.02801 14.2928 7.15651 14.689 7.09012 15.0774L6.18463 20.3742C6.13281 20.6773 6.44597 20.8893 6.69906 20.7559L11.4403 18.2551C11.7906 18.0703 12.2096 18.0703 12.5599 18.2551L17.3011 20.7559C17.5542 20.8893 17.8674 20.6773 17.8156 20.3742L16.9101 15.0774C16.8437 14.689 16.9722 14.2928 17.2539 14.0173L21.0896 10.2661C21.3066 10.0539 21.1807 9.69127 20.8934 9.64937L15.5926 8.87659ZM13.3951 2.87C12.8245 1.71 11.1757 1.71 10.6051 2.87L8.23453 7.68914L2.93372 8.46193C1.65777 8.64794 1.14829 10.2211 2.07157 11.1241L5.90728 14.8752L5.00179 20.172C4.78383 21.4469 6.11767 22.4192 7.25891 21.8173L12.0001 19.3165L16.7413 21.8173C17.8825 22.4192 19.2164 21.4469 18.9984 20.172L18.0929 14.8752L21.9286 11.124C22.8519 10.2211 22.3424 8.64794 21.0665 8.46193L15.7657 7.68914L13.3951 2.87Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.c7378945ea7d6c2588f14a761ea14600.svg";
export { ForwardRef as ReactComponent };